function initVideoModal() {
 
  document.querySelectorAll('[id^="videoModal-"]').forEach(modal => {
    initSingleModal(modal);
  });
}

function initSingleModal(modal) {
  let modalSwiper;
  let isMobile = window.innerWidth <= 768;
  const desktopVideo = modal.querySelector('.desktop-modal video');
  let currentElement = null;

  const videoPlayingStates = new Map();

  modal.youtubePlayer = null;

  modal.isMuted = true;
  let observer = null;
  let currentSection = null;
  let currentVideoElements = null;
  let isVideoSwitching = false;  
  modal.autoplayEnabled = false;  


  const sectionId = modal.id.replace('videoModal-', '');

  // 初始化 YouTube API
  window.onYouTubeIframeAPIReady = function() {
    console.log('YouTube API Ready');
  };


  function updateProductBoxWidth() {
    const productBoxes = modal.querySelectorAll('.product-link-box');
    productBoxes.forEach(box => {
      if (isMobile) {
        const modalMain = box.closest('.modal-main');
        if (!modalMain) return;
        
        const videoWidth = modalMain.offsetWidth;
  
        const maxWidth = Math.min(videoWidth, window.innerWidth * 0.9);
        box.style.width = `${maxWidth}px`;

        box.style.bottom = 'calc(100% * 0.075)';
      } else {
        // 桌面端：等待一小段时间确保视频/iframe已加载
        // setTimeout(() => {
        //   const activeVideo = modal.querySelector('.desktop-modal video:not([style*="display: none"])');
        //   const activeYoutubeContainer = modal.querySelector('.desktop-modal .youtube-container:not([style*="display: none"])');
          
        //   if (activeVideo && activeVideo.offsetWidth) {
        //     box.style.width = `${activeVideo.offsetWidth * 0.95}px`;
        //   } else if (activeYoutubeContainer) {
        //     const youtubeIframe = activeYoutubeContainer.querySelector('iframe');
        //     if (youtubeIframe && youtubeIframe.offsetWidth) {
        //       box.style.width = `${youtubeIframe.offsetWidth * 0.9}px`;
        //     } else {
        //       box.style.width = `${activeYoutubeContainer.offsetWidth * 0.9}px`;
        //     }
        //   }
        // }, 100);
      }
    });
  }

  function createYoutubePlayer(container, videoId, callback) {
    container.innerHTML = '';
    container.style.display = 'block';
    
    const playerDiv = document.createElement('div');
    playerDiv.id = 'youtube-player-' + Date.now();
    container.appendChild(playerDiv);
    
    // 使用当前的全局静音状态
    const currentMuteState = modal.isMuted;
    
    if (typeof YT !== 'undefined' && YT.Player) {
      try {
        modal.youtubePlayer = new YT.Player(playerDiv.id, {
          videoId: videoId,
          height: '100%',
          width: '100%',
          playerVars: {
            autoplay: 1,
            playsinline: 1,
            controls: 1,
            rel: 0,
            showinfo: 0,
            modestbranding: 1,
            fs: 1,
            loop: 0,
            mute: 1, // 总是以静音开始
            enablejsapi: 1,
            origin: document.location.protocol + '//' + document.location.hostname
          },
          events: {
            onReady: (event) => {
              try {
                modal.youtubePlayer = event.target;
                modal.currentYoutubeContainer = container;
                
                // 不更新静音按钮状态，让它保持原样
                callback(event);
                updateProductBoxWidth();
              } catch (error) {
                console.error('YouTube player onReady error:', error);
                retryPlayer();
              }
            }
          }
        });
      } catch (error) {
        console.error('YouTube player creation error:', error);
        retryPlayer();
      }
    }
  }

  // 修改 updateAllVideosMuteState 函数
  function updateAllVideosMuteState(isMuted) {
    // 保存全局静音状态到 localStorage
    localStorage.setItem('globalMuteState', isMuted);
    
    // 更新所有模态框的静音状态
    document.querySelectorAll('[id^="videoModal-"]').forEach(modalElement => {
      modalElement.isMuted = isMuted;
      
      // 更新普通视频的静音状态
      const videos = modalElement.querySelectorAll('video');
      videos.forEach(video => {
        video.muted = isMuted;
      });
      
      // 更新 YouTube 播放器的静音状态
      if (modalElement.youtubePlayer && typeof modalElement.youtubePlayer.isMuted === 'function') {
        try {
          if (isMuted) {
            modalElement.youtubePlayer.mute();
          } else {
            modalElement.youtubePlayer.unMute();
          }
        } catch (error) {
          console.error('Error updating YouTube player mute state:', error);
        }
      }
      
      // 更新静音按钮的显示状态
      const muteControls = modalElement.querySelectorAll('.mute-control');
      muteControls.forEach(control => {
        const volumeOn = control.querySelector('.icon-volume-on');
        const volumeOff = control.querySelector('.icon-volume-off');
        if (volumeOn && volumeOff) {
          volumeOn.style.display = isMuted ? 'none' : 'block';
          volumeOff.style.display = isMuted ? 'block' : 'none';
        }
      });
    });
  }


  function initMuteControls() {
    const muteControls = document.querySelectorAll('.mute-control');
    
    // 每次刷新页面时，强制设置为静音状态
    const initialMuteState = true;
    
    // 初始化所有模态框的静音状态
    document.querySelectorAll('[id^="videoModal-"]').forEach(modalElement => {
      modalElement.isMuted = initialMuteState;
    });
    
    // 更新所有视频和按钮的状态
    updateAllVideosMuteState(initialMuteState);
    
    muteControls.forEach(control => {
      if (control.dataset.initialized) return;
      
      control.dataset.initialized = 'true';
      
      control.addEventListener('click', (e) => {
        e.stopPropagation();
        
        if (control.dataset.processing === 'true') return;
        control.dataset.processing = 'true';
        
        // 切换全局静音状态
        const newMuteState = !modal.isMuted;
        updateAllVideosMuteState(newMuteState);
        
        setTimeout(() => {
          control.dataset.processing = 'false';
        }, 300);
      });
    });
  }

  function initMobileSwiper(initialIndex) {
    try {
      const modalSwiper = new Swiper('.modal-swiper', {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        touchRatio: 1.5,
        resistance: true,
        resistanceRatio: 0.5,
        touchAngle: 45,
        threshold: 5,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        initialSlide: initialIndex,
        speed: 400,
        followFinger: true,
        shortSwipes: false,
        longSwipes: true,
        longSwipesRatio: 0.2,
        longSwipesMs: 100,
        momentumRatio: 1,
        momentumVelocityRatio: 1,
        touchEventsTarget: 'wrapper',
        on: {
          init: function() {
            updateProductInfo(this.realIndex);
          },
          touchStart: function() {
          
            const currentSlide = this.slides[this.activeIndex];
            const video = currentSlide.querySelector('video');
            if (video && video.style.display === 'block') {
              video.dataset.wasPlaying = !video.paused;
            }
          },
          touchMove: function() {
      
            return true;
          },
          touchEnd: function() {
       
            if (Math.abs(this.touches.diff) > 50) {
              this.allowSlideNext = true;
              this.allowSlidePrev = true;
          
              this.setTransition(this.params.speed);
            } else {
    
              const currentSlide = this.slides[this.activeIndex];
              const video = currentSlide.querySelector('video');
              if (video && video.style.display === 'block' && video.dataset.wasPlaying === 'true') {
                video.play().catch(console.error);
              }
             
              this.setTransition(300);
              this.setTranslate(this.getTranslate());
            }
          },
          setTransition: function(speed) {

            const slides = this.slides;
            for (let i = 0; i < slides.length; i++) {
              slides[i].style.transition = `${speed}ms`;
              slides[i].querySelector('.modal-main').style.transition = `${speed}ms`;
            }
          },
          slideChange: function() {
            console.log('Slide changed');
            const currentSlide = this.slides[this.activeIndex];
            if (!currentSlide) return;
            
            // 保存当前的静音状态和图标状态
            const currentMuteState = modal.isMuted;
            const muteControl = currentSlide.querySelector('.mute-control');
            const volumeOn = muteControl?.querySelector('.icon-volume-on');
            const volumeOff = muteControl?.querySelector('.icon-volume-off');
            
            // 保存当前图标显示状态
            const currentVolumeOnDisplay = volumeOn?.style.display;
            const currentVolumeOffDisplay = volumeOff?.style.display;

            // 清理之前的视频
            const previousSlide = this.slides[this.previousIndex];
            if (previousSlide) {
              // 清理普通视频
              const previousVideo = previousSlide.querySelector('video');
              if (previousVideo) {
                previousVideo.pause();
                previousVideo.removeAttribute('src');
                previousVideo.removeEventListener('ended', handleVideoEnd);
                previousVideo.load();
                previousVideo.style.display = 'none';
              }
              
              // 清理 YouTube 视频
              const previousYoutubeContainer = previousSlide.querySelector('.youtube-container');
              if (previousYoutubeContainer && modal.youtubePlayer) {
                try {
                  // 检查 YouTube 播放器方法是否存在
                  if (modal.youtubePlayer && typeof modal.youtubePlayer.getPlayerState === 'function') {
                    // 只有当播放器处于可用状态时才调用方法
                    if (modal.youtubePlayer.getPlayerState() !== undefined) {
                      if (typeof modal.youtubePlayer.stopVideo === 'function') {
                        modal.youtubePlayer.stopVideo();
                      }
                      if (typeof modal.youtubePlayer.destroy === 'function') {
                        modal.youtubePlayer.destroy();
                      }
                    }
                  }
                  modal.youtubePlayer = null;
                  previousYoutubeContainer.innerHTML = '';
                  previousYoutubeContainer.style.display = 'none';
                } catch (error) {
                  console.error('Error cleaning up previous YouTube player:', error);
                  // 即使出错也要尝试清理
                  try {
                    previousYoutubeContainer.innerHTML = '';
                    previousYoutubeContainer.style.display = 'none';
                    modal.youtubePlayer = null;
                  } catch (cleanupError) {
                    console.error('Error during fallback cleanup:', cleanupError);
                  }
                }
              }
            }
            
            // 加载新视频
            const index = this.realIndex;
            const originalVideo = currentVideoElements[index];
            if (!originalVideo) return;
            
            const videoUrl = originalVideo.dataset.videoShopify;
            const youtubeUrl = originalVideo.dataset.videoYoutube;
            
            // 清理当前 slide 中的所有视频
            const allVideos = currentSlide.querySelectorAll('video');
            allVideos.forEach(v => {
              v.pause();
              v.removeAttribute('src');
              v.load();
              v.style.display = 'none';
            });
            
            const allYoutubeContainers = currentSlide.querySelectorAll('.youtube-container');
            allYoutubeContainers.forEach(c => {
              c.innerHTML = '';
              c.style.display = 'none';
            });
            
            // 加载新的视频内容
            const video = currentSlide.querySelector('video');
            const container = currentSlide.querySelector('.youtube-container');
            
            if (youtubeUrl) {
              const videoId = handleYoutubeShorts(youtubeUrl);
              if (videoId && container) {
                if (video) video.style.display = 'none';
                container.style.display = 'block';
                
                // 确保之前的 YouTube 播放器被清理
                if (modal.youtubePlayer) {
                  try {
                    modal.youtubePlayer.destroy();
                  } catch (error) {
                    console.error('Error destroying previous YouTube player:', error);
                  }
                  modal.youtubePlayer = null;
                }
                
                createYoutubePlayer(container, videoId, (event) => {
                  setTimeout(() => {
                    event.target.playVideo();
                    // 不立即更新图标状态，保持原有状态
                    if (muteControl) {
                      volumeOn.style.display = currentVolumeOnDisplay;
                      volumeOff.style.display = currentVolumeOffDisplay;
                    }
                    
                    // 设置 YouTube 播放器的静音状态，但不触发图标更新
                    if (currentMuteState) {
                      event.target.mute();
                    } else {
                      event.target.unMute();
                    }
                    
                    hideLoadingOverlay();
                    updateProductInfo(index);
                  }, 100);
                });
              }
            } else if (videoUrl) {
              if (container) container.style.display = 'none';
              if (video) {
                video.style.display = 'block';
                const fullUrl = videoUrl.startsWith('//') ? 'https:' + videoUrl : videoUrl;
                
                video.removeEventListener('ended', handleVideoEnd);
                video.addEventListener('ended', handleVideoEnd);
                
                video.addEventListener('loadeddata', () => {
                  video.play().catch(console.error);
                  // 使用当前的全局静音状态
                  video.muted = modal.isMuted;
                  hideLoadingOverlay();
                  updateProductInfo(index);
                }, { once: true });

                video.src = fullUrl;
                video.muted = modal.isMuted;
                video.load();
              }
            }
            
            updateProductInfo(index);
          },
          slideChangeTransitionEnd: function() {
  
            const currentSlide = this.slides[this.activeIndex];
            if (currentSlide) {
              const video = currentSlide.querySelector('video');
              if (video && video.style.display === 'block') {
                video.play().catch(console.error);
              }
            }
          }
        }
      });


      const productInfoSwiper = new Swiper('.product-info-swiper', {
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 10,
        nested: true,
        resistance: true,
        watchSlidesProgress: true,
        noSwipingClass: 'swiper-no-swiping',
        pagination: {
          el: '.product-info-pagination',
          clickable: true,
        },
        on: {
          touchStart: function() {
            modalSwiper.allowTouchMove = false;
          },
          touchEnd: function() {
            modalSwiper.allowTouchMove = true;
          }
        }
      });

      return modalSwiper;
    } catch (error) {
      console.error('Error initializing swiper:', error);
      return null;
    }
  }

  function createObserver() {
    observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.target.tagName === 'VIDEO') {
          if (!entry.isIntersecting) {
            entry.target.pause();
            entry.target.muted = true;
          } else {
            entry.target.muted = false;
            entry.target.play().catch(err => console.log('Video play error:', err));
          }
        } else if (entry.target.classList.contains('youtube-container')) {
          if (!entry.isIntersecting && modal.youtubePlayer) {
            modal.youtubePlayer.pauseVideo();
            modal.youtubePlayer.mute();
          } else if (modal.youtubePlayer) {
            modal.youtubePlayer.playVideo();
            modal.youtubePlayer.unMute();
          }
        }
      });
    }, {
      threshold: 0.5
    });
  }

  function observeVideo(video) {
    if (observer) {
      observer.observe(video);
    }
  }

  function unobserveVideo(video) {
    if (observer) {
      observer.unobserve(video);
    }
  }


  function initSwiper(initialIndex) {
    if (isMobile) {
      modalSwiper = initMobileSwiper(initialIndex);
    } else {
      modalSwiper = initDesktopSwiper(initialIndex);
    }
  }


  
  function initProductInfoSwiper() {
    const productInfoContainer = modal.querySelector('.product-info-swiper');
    if (!productInfoContainer) return;
    
    const productSwiper = new Swiper(productInfoContainer, {
      slidesPerView: 'auto',
      freeMode: {
        enabled: true,
        sticky: false,
        momentumBounce: false,
      },
      watchOverflow: true,
      resistanceRatio: 0,
      direction: 'horizontal',
      touchRatio: 1,
      observer: true,
      observeParents: true,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      touchEventsTarget: 'container',
      touchStartPreventDefault: false,
      touchMoveStopPropagation: true,
      touchReleaseOnEdges: true
    });
  }

  function openVideoModal(element, section) {
    console.log('Opening modal for element:', element);
    console.log('Element dataset:', element.dataset);
    console.log('Opening modal for section:', sectionId);
    console.log('Video element:', element);
    
    currentVideoElements = Array.from(section.querySelectorAll('.shoppable-videos__video'));
    console.log('All video elements:', currentVideoElements);
    currentSection = section;
    
    if (!observer) {
      createObserver();
    }
    currentElement = element;
    const index = currentVideoElements.indexOf(element);
    const videoUrl = element.dataset.videoShopify;
    const youtubeUrl = element.dataset.videoYoutube;
    
    modal.classList.add('active');
    modal.style.display = 'flex';
    
   
    if (videoUrl && !youtubeUrl) {
      const modalContent = modal.querySelector('.modal-content');
      if (modalContent) {
        modalContent.classList.add('loading');
      }
      showLoadingOverlay();
    }

    if (isMobile) {

      const modalContent = modal.querySelector('.modal-content');
      if (modalContent) {
        modalContent.classList.add('loading');
      }
      showLoadingOverlay();

    
      const currentSlide = modal.querySelector(`.mobile-modal`);
      if (currentSlide) {
        const video = currentSlide.querySelector('video');
        const container = currentSlide.querySelector('.youtube-container');
        
 
        const allVideos = modal.querySelectorAll('.mobile-modal video');
        allVideos.forEach(v => {
          v.pause();
          v.removeAttribute('src');
          v.load();
        });
        
        const allContainers = modal.querySelectorAll('.mobile-modal .youtube-container');
        allContainers.forEach(c => {
          c.style.display = 'none';
          c.innerHTML = '';
        });
        
        if (youtubeUrl) {
          const videoId = handleYoutubeShorts(youtubeUrl);
          if (videoId && container) {
            if (video) video.style.display = 'none';
            container.style.display = 'block';
            createYoutubePlayer(container, videoId, (event) => {
              setTimeout(() => {
                event.target.playVideo();
         
                const modalContent = modal.querySelector('.modal-content');
                if (modalContent) {
                  modalContent.classList.remove('loading');
                }
                hideLoadingOverlay();
                updateProductInfo(index);
              }, 100);
            });
          }
        } else if (videoUrl) {
          if (video) {
            if (container) container.style.display = 'none';
            video.style.display = 'block';
            const fullUrl = videoUrl.startsWith('//') ? 'https:' + videoUrl : videoUrl;
           
        
            video.addEventListener('loadeddata', () => {
      
              const modalContent = modal.querySelector('.modal-content');
              if (modalContent) {
                modalContent.classList.remove('loading');
              }
              hideLoadingOverlay();
              video.play().catch(console.error);
    
              video.muted = modal.isMuted;
              const muteControl = video.closest('.modal-main').querySelector('.mute-control');
              if (muteControl) {
                const volumeOn = muteControl.querySelector('.icon-volume-on');
                const volumeOff = muteControl.querySelector('.icon-volume-off');
                volumeOn.style.display = 'none';
                volumeOff.style.display = 'block';
              }
              updateProductInfo(index);
            }, { once: true });

    
            video.addEventListener('error', () => {
              console.error('Video loading failed');
              hideLoadingOverlay();
            }, { once: true });

            video.src = fullUrl;
            video.muted = modal.isMuted;
            video.load();
          }
        }
      }


      initSwiper(index);
  
      if (!modal.dataset.muteControlsInitialized) {
        initMuteControls();
        modal.dataset.muteControlsInitialized = 'true';
      }
      handleTouchEvents();
      initProductInfoSwiper();
    } else {

      // 强制设置为静音状态
      modal.isMuted = true;
      
      if (youtubeUrl) {
        const videoId = handleYoutubeShorts(youtubeUrl);
        if (videoId) {
          const container = modal.querySelector('.desktop-modal .youtube-container');
          const video = modal.querySelector('.desktop-modal video');
          const modalMain = modal.querySelector('.desktop-modal .modal-main');
          
          if (container) {
            if (video) {
              video.style.display = 'none';
              video.pause();
              video.removeAttribute('src');
              video.load();
            }
            
            if (youtubeUrl.includes('/shorts/')) {
              modalMain.setAttribute('data-video-type', 'shorts');
            } else {
              modalMain.removeAttribute('data-video-type');
            }
            
            createYoutubePlayer(container, videoId, (event) => {
              // 使用全局静音状态
              if (modal.isMuted) {
                event.target.mute();
              } else {
                event.target.unMute();
              }
              event.target.playVideo();
              updateProductInfo(index);
            });
          }
        }
      } else if (videoUrl) {
   
        const container = modal.querySelector('.desktop-modal .youtube-container');
        if (container) {
          container.style.display = 'none';
          container.innerHTML = '';
        }
        
        if (desktopVideo) {
          // 保存当前的静音状态
          const currentMuted = modal.isMuted;
          
          desktopVideo.style.display = 'block';
          const fullUrl = videoUrl.startsWith('//') ? 'https:' + videoUrl : videoUrl;
          
          desktopVideo.removeEventListener('ended', handleVideoEnd);
          desktopVideo.addEventListener('ended', handleVideoEnd);
          
          desktopVideo.addEventListener('loadeddata', () => {
            const modalContent = modal.querySelector('.modal-content');
            if (modalContent) {
              modalContent.classList.remove('loading');
            }
            hideLoadingOverlay();
            // 使用保存的静音状态
            modal.isMuted = currentMuted;
            desktopVideo.muted = currentMuted;
            desktopVideo.play().catch(console.error);
            updateProductInfo(index);
            // 更新静音按钮状态
            updateAllVideosMuteState(currentMuted);
          }, { once: true });

          desktopVideo.src = fullUrl;
          desktopVideo.muted = currentMuted;
          desktopVideo.loop = false;
          desktopVideo.load();
        }
      }
    }

    updateProductBoxWidth();
    
    if (!isMobile) {
      updateNavigationButtons();
    }

 
    if (!modal.dataset.muteControlsInitialized) {
      initMuteControls();
      modal.dataset.muteControlsInitialized = 'true';
    }

  
    modal.autoplayEnabled = section.dataset.autoplayNext === 'true';

    // 初始化产品链接
    if (!modal.dataset.productLinksInitialized) {
      initProductLinks();
    }
  }

  function updateProductInfo(index) {
    const videoElement = currentSection.querySelector(`.shoppable-videos__video[data-index="${index}"]`);
    if (!videoElement) return;

    const productsData = videoElement.dataset.products;
    if (!productsData || productsData.trim() === '[]') {
      return;
    }

    try {
      const products = JSON.parse(productsData);
      if (!Array.isArray(products) || products.length === 0) {
        return;
      }

      const blockId = videoElement.dataset.blockId;
      const isMobile = window.innerWidth <= 768;
      const modalMain = isMobile 
        ? modal.querySelector('.mobile-modal .swiper-wrapper').children[index].querySelector('.modal-main')
        : modal.querySelector('.desktop-modal .modal-main');

      if (!modalMain) return;

      const videoEl = modalMain.querySelector('video:not([style*="display: none"])');
      const youtubeContainer = modalMain.querySelector('.youtube-container:not([style*="display: none"])');
      const videoWidth = videoEl ? videoEl.offsetWidth : 
                        (youtubeContainer ? youtubeContainer.offsetWidth : modalMain.offsetWidth);
      
    // 移除现有的产品容器
    const existingContainer = modalMain.querySelector('.product-boxes-container');
    if (existingContainer) {
      existingContainer.remove();
    }
    
    // 创建新的产品容器
    const productBoxesContainer = document.createElement('div');
    productBoxesContainer.className = 'product-boxes-container';
    
    if (isMobile) {
      productBoxesContainer.classList.add('mobile');
    } else {
      // 桌面端设置容器宽度
      const containerWidth = videoWidth * 0.95; // 稍微比视频窄一点
      productBoxesContainer.style.width = `${containerWidth}px`;
      productBoxesContainer.style.display = 'flex';
      productBoxesContainer.style.justifyContent = 'center';
    }

    if (products.length === 1) {
      // 单个产品的处理
      const productBox = createProductBox(products[0], blockId);
      if (!isMobile) {
        productBox.style.width = '100%';
      }
      productBoxesContainer.appendChild(productBox);
    } else {
      // 多个产品的处理
      const swiperContainer = document.createElement('div');
      swiperContainer.className = 'swiper product-info-swiper';
      
      if (!isMobile) {
        swiperContainer.style.width = '100%';
        swiperContainer.style.overflow = 'hidden';
      }

      const swiperWrapper = document.createElement('div');
      swiperWrapper.className = 'swiper-wrapper';

      products.forEach(product => {
        const swiperSlide = document.createElement('div');
        swiperSlide.className = 'swiper-slide';
        
        const productBox = createProductBox(product, blockId);
        if (!isMobile) {
          productBox.style.width = '100%';
        }
        
        swiperSlide.appendChild(productBox);
        swiperWrapper.appendChild(swiperSlide);
      });

      // 添加分页器
      const pagination = document.createElement('div');
      pagination.className = 'swiper-pagination product-info-pagination';
      
      swiperContainer.appendChild(swiperWrapper);
      swiperContainer.appendChild(pagination);
      productBoxesContainer.appendChild(swiperContainer);

      // 初始化 Swiper
      new Swiper(swiperContainer, {
        slidesPerView: isMobile ? 1 : 1.2,
        spaceBetween: isMobile ? 10 : 20,
        centeredSlides: !isMobile,
        loop: products.length > 1,
        slideToClickedSlide: true,
        pagination: {
          el: pagination,
          clickable: true,
          type: 'bullets',
        },
        width: isMobile ? null : videoWidth * 0.95,
        breakpoints: {
          769: {
            width: videoWidth * 0.95
          }
        }
      });
    }

    modalMain.appendChild(productBoxesContainer);
    
  } catch (error) {
    console.error('Error updating product info:', error);
  }
}


  function createProductBox(product, blockId) {
    const productBox = document.createElement('div');
    productBox.className = 'product-link-box';
    productBox.dataset.blockId = blockId;
    productBox.dataset.productId = product.id;
    
    // 获取 Shopify 路由前缀
    const root = window.Shopify && window.Shopify.routes ? 
      (Shopify.routes.root == '/' ? '' : Shopify.routes.root) : '';
    
    productBox.innerHTML = `
      <div class="product-info">
        <div class="product-image">
          <img src="${product.image}" loading="lazy" alt="${product.title}">
        </div>
        <div class="product-details">
          <div class="product-title">${product.title}</div>
          <div class="product-price">
            <span class="product-price">
              <span class="money">${product.price}</span>
            </span>
          </div>
        </div>
      </div>
      <a href="${root}${product.url}" class="product-link">
        <span>Shop Now</span>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M15 19L8 12L15 5" stroke="white" stroke-width="2"/>
        </svg>
      </a>
    `;
    
    return productBox;
  }

  function closeModal() {
    modal.classList.remove('active');
    modal.style.display = 'none';
    currentElement = null;
    
    // 重置静音状态和图标
    modal.isMuted = true; // 重置为静音状态
    
    // 更新所有静音按钮的图标状态
    const muteControls = modal.querySelectorAll('.mute-control');
    muteControls.forEach(control => {
      const volumeOn = control.querySelector('.icon-volume-on');
      const volumeOff = control.querySelector('.icon-volume-off');
      if (volumeOn && volumeOff) {
        volumeOn.style.display = 'none';
        volumeOff.style.display = 'block';
      }
    });

    // 清理视频
    destroyModalSwiper();

    if (modal.youtubePlayer) {
      try {
        modal.youtubePlayer.stopVideo();
        setTimeout(() => {
          try {
            modal.youtubePlayer.destroy();
            modal.youtubePlayer = null;
          } catch (error) {
            console.error('Error destroying YouTube player:', error);
          }
        }, 100);
      } catch (error) {
        console.error('Error stopping YouTube video:', error);
      }
    }

    const youtubeContainers = modal.querySelectorAll('.youtube-container');
    youtubeContainers.forEach(container => {
      try {
        const iframe = container.querySelector('iframe');
        if (iframe) {
          iframe.src = '';
          iframe.remove();
        }
        container.innerHTML = '';
      } catch (error) {
        console.error('Error cleaning YouTube container:', error);
      }
      const touchOverlay = container.parentElement.querySelector('.youtube-touch-overlay');
      if (touchOverlay) {
        touchOverlay.remove();
      }
    });

    if (isMobile) {
      const videos = modal.querySelectorAll('.mobile-modal video');
      videos.forEach(video => {
        video.pause();
        video.removeAttribute('src');
        video.load();
      });
    } else {
      desktopVideo.pause();
      desktopVideo.removeAttribute('src');
      desktopVideo.load();
    }
    
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }


  if (!isMobile) {
    const prevButton = modal.querySelector('.modal-nav-prev');
    const nextButton = modal.querySelector('.modal-nav-next');
    
    let isNavigating = false;
    
    function navigateToVideo(nextElement, direction) {
      if (!nextElement || isNavigating) return;
      
      isNavigating = true;
      
      // 保存当前的全局静音状态
      const currentMuteState = localStorage.getItem('globalMuteState') === 'true';
      
      // 清理当前视频
      if (desktopVideo) {
        desktopVideo.pause();
        desktopVideo.removeAttribute('src');
        desktopVideo.load();
        desktopVideo.removeEventListener('ended', handleVideoEnd);
      }
      
      if (modal.youtubePlayer) {
        try {
          modal.youtubePlayer.stopVideo();
          modal.youtubePlayer.destroy();
        } catch (error) {
          console.error('Error cleaning up YouTube player:', error);
        }
        modal.youtubePlayer = null;
      }
      
      // 更新当前元素
      currentElement = nextElement;
      
      // 设置全局静音状态
      modal.isMuted = currentMuteState;
      
      // 打开新视频
      openVideoModal(nextElement, currentSection);
      
      // 更新产品信息和按钮状态
      const newIndex = Array.from(currentVideoElements).indexOf(nextElement);
      updateProductInfo(newIndex);
      updateNavigationButtons();
      
      // 确保应用正确的静音状态
      setTimeout(() => {
        updateAllVideosMuteState(currentMuteState);
        isNavigating = false;
      }, 300);
    }
    
    prevButton.addEventListener('click', () => {
      if (!currentElement || !currentSection) return;
      
      const currentIndex = Array.from(currentVideoElements).indexOf(currentElement);
      const totalVideos = currentVideoElements.length;
      let prevIndex = (currentIndex - 1 + totalVideos) % totalVideos;
      
      let prevElement = currentVideoElements[prevIndex];
      while (prevIndex !== currentIndex && (!prevElement || (!prevElement.dataset.videoShopify && !prevElement.dataset.videoYoutube))) {
        prevIndex = (prevIndex - 1 + totalVideos) % totalVideos;
        prevElement = currentVideoElements[prevIndex];
      }
      
      navigateToVideo(prevElement, 'prev');
    });

    nextButton.addEventListener('click', () => {
      if (!currentElement || !currentSection) return;
      
      const currentIndex = Array.from(currentVideoElements).indexOf(currentElement);
      const totalVideos = currentVideoElements.length;
      let nextIndex = (currentIndex + 1) % totalVideos;
      
      let nextElement = currentVideoElements[nextIndex];
      while (nextIndex !== currentIndex && (!nextElement || (!nextElement.dataset.videoShopify && !nextElement.dataset.videoYoutube))) {
        nextIndex = (nextIndex + 1) % totalVideos;
        nextElement = currentVideoElements[nextIndex];
      }
      
      navigateToVideo(nextElement, 'next');
    });
  }


  document.addEventListener('click', function(e) {
    const videoElement = e.target.closest('.shoppable-videos__video');
    const section = e.target.closest('.shoppable-videos');
    

    if (videoElement && section && section.dataset.sectionId === sectionId) {
      e.preventDefault();
      e.stopPropagation();
      openVideoModal(videoElement, section);
    }
  });

  const closeButton = modal.querySelector('.close-button');
  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }


  modal.addEventListener('click', (e) => {

    if (isMobile) {
      const closeButton = e.target.closest('.close-button');
      if (closeButton) {
        closeModal();
      }
      return;
    }
    

    const clickedButton = e.target.closest('.modal-nav button');
    if (clickedButton && clickedButton.disabled) {
      return;
    }
    
    if (!e.target.closest('video') && 
        !e.target.closest('.modal-nav') && 
        !e.target.closest('.close-button') &&
        !e.target.closest('.product-link-box') &&
        !e.target.closest('.mute-control')) {
      closeModal();
    }
  });



  function handleYoutubeShorts(url) {
    if (url && url.includes('shorts')) {
  
      const urlObj = new URL(url);
      const pathParts = urlObj.pathname.split('/');
      const shortsIndex = pathParts.indexOf('shorts');
      return shortsIndex !== -1 && pathParts[shortsIndex + 1] ? pathParts[shortsIndex + 1] : null;
    }
    return null;
  }


  function destroyModalSwiper() {
    if (modalSwiper && typeof modalSwiper.destroy === 'function') {
      try {
        modalSwiper.destroy(true, true);
        modalSwiper = null;
      } catch (error) {
        console.log('Error destroying swiper:', error);
      }
    }
  }

  window.addEventListener('resize', () => {
    isMobile = window.innerWidth <= 768;
    updateProductBoxWidth();
  });


  function showLoadingOverlay() {
    const modalContent = modal.querySelector('.modal-content');
    if (!modalContent) return;
    
    const existingOverlay = modalContent.querySelector('.video-loading-overlay');
    if (!existingOverlay) {
      const overlay = document.createElement('div');
      overlay.className = 'video-loading-overlay';
      overlay.innerHTML = '<div class="video-loading-spinner"></div>';
      modalContent.appendChild(overlay);
    }
  }


  function hideLoadingOverlay() {
    const overlay = modal.querySelector('.video-loading-overlay');
    if (overlay) {
      overlay.remove();
    }
  }

  function updateVideo(index) {
    const videoElement = currentVideoElements[index];
    if (!videoElement) return;

    const videoUrl = videoElement.dataset.videoShopify;
    const youtubeUrl = videoElement.dataset.videoYoutube;


    isVideoSwitching = true;
    showLoadingOverlay();
    
    function cleanupCurrentVideo() {
      

      const currentVideos = modal.querySelectorAll('video');
      currentVideos.forEach(video => {
        try {
          video.pause();
          video.currentTime = 0;
          video.src = '';
          video.load();
          video.style.display = 'none';
          video.muted = true;
        } catch (error) {
          console.error('Error stopping video:', error);
        }
      });


      if (modal.youtubePlayer) {
        try {
          const player = modal.youtubePlayer;
          if (player && typeof player.stopVideo === 'function') {
            player.stopVideo();
          }
          if (player && typeof player.mute === 'function') {
            player.mute();
          }
          setTimeout(() => {
            try {
              if (player && typeof player.destroy === 'function') {
                player.destroy();
              }
            } catch (error) {
              console.error('Error destroying YouTube player:', error);
            } finally {
              modal.youtubePlayer = null;
            }
          }, 100);
        } catch (error) {
          console.error('Error stopping YouTube video:', error);
          modal.youtubePlayer = null;
        }
      }


      const youtubeContainers = modal.querySelectorAll('.youtube-container');
      youtubeContainers.forEach(container => {
        container.style.display = 'none';
        container.innerHTML = '';
      });
    }
    

    cleanupCurrentVideo();
    

    setTimeout(() => {
      if (youtubeUrl) {
        const videoId = handleYoutubeShorts(youtubeUrl);
        if (videoId) {
          const container = modal.querySelector('.youtube-container');
          if (container) {
            container.style.display = 'block';
            createYoutubePlayer(container, videoId, (event) => {
              if (!isVideoSwitching) {
                event.target.playVideo();
                event.target.mute(); // 初始静音
                setTimeout(() => {
                  updateAllVideosMuteState(modal.isMuted); 
                  hideLoadingOverlay();
                  updateProductInfo(index);
                }, 100);
              }
            });
          }
        }
      } else if (videoUrl) {
        const video = modal.querySelector('video');
        if (video) {
          const fullUrl = videoUrl.startsWith('//') ? 'https:' + videoUrl : videoUrl;
          
          video.style.display = 'block';
          video.muted = true; 
          
          video.addEventListener('loadeddata', () => {
            if (!isVideoSwitching) {
              updateAllVideosMuteState(modal.isMuted);
              video.play().catch(console.error);
              hideLoadingOverlay();
              updateProductInfo(index);
            }
          }, { once: true });

          video.src = fullUrl;
          video.load();
        }
      }
    }, 200);

 
    setTimeout(() => {
      isVideoSwitching = false;
    }, 400);
  }


  function handleTouchEvents() {
    const productBoxes = document.querySelectorAll('.product-link-box');
    productBoxes.forEach(box => {
      box.addEventListener('touchstart', (e) => {
        e.stopPropagation();
      }, { passive: true });
      
      box.addEventListener('touchmove', (e) => {
        e.stopPropagation();
      }, { passive: true });
    });
  }

 
  function handleVideoEnd() {
    console.log('Video ended, autoplay:', modal.autoplayEnabled);
    
    if (modal.autoplayEnabled) {
      if (isMobile && modalSwiper) {
        console.log('Handling mobile video end');
        
        // 清理当前视频
        const currentSlide = modalSwiper.slides[modalSwiper.activeIndex];
        if (currentSlide) {
          const currentVideo = currentSlide.querySelector('video');
          if (currentVideo) {
            currentVideo.pause();
            currentVideo.removeAttribute('src');
            currentVideo.load();
            currentVideo.removeEventListener('ended', handleVideoEnd);
          }
        }
        
        // 切换到下一个视频
        modalSwiper.slideNext();
        
        // 等待切换完成后播放新视频
        setTimeout(() => {
          const newSlide = modalSwiper.slides[modalSwiper.activeIndex];
          if (newSlide) {
            const newVideo = newSlide.querySelector('video');
            if (newVideo && newVideo.style.display === 'block') {
              // 重新设置视频源并播放
              const videoUrl = currentVideoElements[modalSwiper.realIndex].dataset.videoShopify;
              if (videoUrl) {
                const fullUrl = videoUrl.startsWith('//') ? 'https:' + videoUrl : videoUrl;
                newVideo.src = fullUrl;
                newVideo.muted = modal.isMuted;
                newVideo.load();
                
                // 添加新的事件监听器
                newVideo.removeEventListener('ended', handleVideoEnd);
                newVideo.addEventListener('ended', handleVideoEnd);
                
                newVideo.addEventListener('loadeddata', () => {
                  newVideo.play().catch(error => {
                    console.error('Error playing next video:', error);
                  });
                }, { once: true });
              }
            }
          }
        }, 300);
      } else {
        // 桌面端处理
        const currentIndex = Array.from(currentVideoElements).indexOf(currentElement);
        const nextIndex = (currentIndex + 1) % currentVideoElements.length;
        const nextElement = currentVideoElements[nextIndex];
        
        if (nextElement) {
          // 清理当前视频时保持静音状态
          if (desktopVideo) {
            const currentMuted = desktopVideo.muted; // 保存当前静音状态
            desktopVideo.pause();
            desktopVideo.removeAttribute('src');
            desktopVideo.load();
            desktopVideo.removeEventListener('ended', handleVideoEnd);
            modal.isMuted = currentMuted; // 保持静音状态
          }
          
          currentElement = nextElement;
          openVideoModal(nextElement, currentSection);
        }
      }
    } else {
      // 循环播放当前视频
      const video = isMobile ? 
        modalSwiper.slides[modalSwiper.activeIndex].querySelector('video') :
        modal.querySelector('.desktop-modal video');
        
      if (video) {
        video.currentTime = 0;
        video.play().catch(console.error);
      }
    }
  }


  function toggleVideoPlayback(videoElement) {
    if (!videoElement) return;
    
    console.log('Toggling video playback');
    console.log('Video paused state:', videoElement.paused);
    
    const modalMain = videoElement.closest('.modal-main');
    
    try {
      if (!videoElement.paused) {
        console.log('Pausing video');
        videoElement.pause();
        if (modalMain) {
          modalMain.setAttribute('data-video-paused', 'true');
        }
      } else {
        console.log('Playing video');
        videoElement.play().catch(error => {
          console.error('Error playing video:', error);
        });
        if (modalMain) {
          modalMain.setAttribute('data-video-paused', 'false');
        }
      }
    } catch (error) {
      console.error('Error in toggleVideoPlayback:', error);
    }
  }

  function toggleYouTubePlayback() {
    if (!modal.youtubePlayer) return;
    
    const modalMain = modal.youtubePlayer.getIframe().closest('.modal-main');
  
    modalMain.setAttribute('data-video-type', 'youtube');
    const videoId = modal.youtubePlayer.getVideoData().video_id;
    const isPlaying = videoPlayingStates.get(videoId) !== false;
    
    if (isPlaying) {
      modal.youtubePlayer.pauseVideo();
    } else {
      modal.youtubePlayer.playVideo();
    }
    videoPlayingStates.set(videoId, !isPlaying);
  }


  function initVideoPlayState(video) {
    if (!video) return;
    const videoId = video.dataset.videoId || 'default';
    const modalMain = video.closest('.modal-main');
    if (modalMain) {
      modalMain.setAttribute('data-video-paused', 'false');
    }
    videoPlayingStates.set(videoId, true);
  }

  function initVideoEvents(video) {
    if (!video) return;
    
    const videoId = Date.now().toString();
    video.dataset.videoId = videoId;
    videoPlayingStates.set(videoId, true);
    

    video.onclick = (e) => {
      e.stopPropagation();
      e.preventDefault();
      toggleVideoPlayback(video);
    };

    video.addEventListener('loadeddata', () => {
      hideLoadingOverlay();
      video.play().catch(console.error);
      initVideoPlayState(video);
    }, { once: true });
  }


  if (isMobile) {
    const mobileModal = modal.querySelector('.mobile-modal');
    
    // 修改静音按钮的点击处理
    const muteControls = modal.querySelectorAll('.mute-control');
    muteControls.forEach(control => {
      if (control.dataset.initialized) return;
      
      control.dataset.initialized = 'true';
      
      // 移除旧的事件监听器
      const newControl = control.cloneNode(true);
      control.parentNode.replaceChild(newControl, control);
      
      // 创建一个触摸事件处理函数
      function handleMuteTouch(e) {
        e.stopPropagation();
        e.preventDefault();
        
        if (newControl.dataset.processing === 'true') return;
        newControl.dataset.processing = 'true';
        
        // 切换全局静音状态
        const newMuteState = !modal.isMuted;
        updateAllVideosMuteState(newMuteState);
        
        // 确保视频继续播放
        const currentSlide = modalSwiper.slides[modalSwiper.activeIndex];
        if (currentSlide) {
          const video = currentSlide.querySelector('video');
          if (video && video.style.display === 'block') {
            // 防止视频暂停
            video.removeEventListener('click', handleVideoClick);
            
            // 如果视频是暂停状态，尝试播放
            if (video.paused) {
              video.play().catch(console.error);
            }
            
            // 延迟重新添加点击事件监听器
            setTimeout(() => {
              video.addEventListener('click', handleVideoClick, {
                capture: true,
                passive: false
              });
            }, 100);
          }
          
          // 如果是 YouTube 视频，确保继续播放
          if (modal.youtubePlayer && 
              typeof modal.youtubePlayer.getPlayerState === 'function') {
            const playerState = modal.youtubePlayer.getPlayerState();
            if (playerState === YT.PlayerState.PAUSED || playerState === YT.PlayerState.CUED) {
              modal.youtubePlayer.playVideo();
            }
          }
        }
        
        setTimeout(() => {
          newControl.dataset.processing = 'false';
        }, 300);
      }
      
      // 添加所有触摸相关的事件监听器
      ['touchstart', 'touchend', 'touchmove', 'click', 'mousedown', 'mouseup'].forEach(eventName => {
        newControl.addEventListener(eventName, (e) => {
          e.stopPropagation();
          e.preventDefault();
          
          // 只在 touchstart 或 click 时处理静音逻辑
          if (eventName === 'touchstart' || eventName === 'click') {
            handleMuteTouch(e);
          }
        }, { 
          capture: true,
          passive: false 
        });
      });
      
      // 添加一个透明的覆盖层来捕获事件
      const overlay = document.createElement('div');
      overlay.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 31;
        pointer-events: none;
      `;
      newControl.parentNode.appendChild(overlay);
    });

    // 修改视频点击处理函数
    function handleVideoClick(e) {
      // 如果点击来自静音按钮或其周围区域，直接返回
      const muteControl = e.target.closest('.mute-control');
      if (muteControl || e.target.closest('.mute-control-overlay')) {
        e.stopPropagation();
        e.preventDefault();
        return;
      }
      
      // 如果点击的是视频控件，不处理
      if (e.target.closest('video::-webkit-media-controls')) {
        return;
      }
      
      e.stopPropagation();
      e.preventDefault();
      
      const video = e.target;
      if (video.tagName === 'VIDEO') {
        try {
          // 单击 - 暂停/播放视频
          if (video.paused) {
            video.play().catch(error => {
              console.error('Error playing video:', error);
            });
          } else {
            video.pause();
          }
          
          const modalMain = video.closest('.modal-main');
          if (modalMain) {
            modalMain.setAttribute('data-video-paused', video.paused);
          }
        } catch (error) {
          console.error('Error handling video click:', error);
        }
      }
    }

    // 添加自定义点击处理
    const videos = modal.querySelectorAll('video');
    videos.forEach(video => {
      // 移除旧的事件监听器
      const newVideo = video.cloneNode(true);
      video.parentNode.replaceChild(newVideo, video);
      
      // 添加自定义点击处理
      newVideo.addEventListener('click', handleVideoClick, {
        capture: true,
        passive: false
      });
      
      // 禁用视频的默认控件行为
      newVideo.controls = false;
      
      newVideo.dataset.hasClickHandler = 'true';
    });


    if (!mobileModal.dataset.hasClickHandler) {
      mobileModal.addEventListener('click', (e) => {
   
        if (e.target.closest('video::-webkit-media-controls')) {
          return;
        }
        
        const youtubeContainer = e.target.closest('.youtube-container');
        if (youtubeContainer && modal.youtubePlayer) {
          toggleYouTubePlayback();
        }
      });
      mobileModal.dataset.hasClickHandler = 'true';
    }
  }

  // 修改桌面端视频点击事件处理
  if (!isMobile) {
    const desktopModal = modal.querySelector('.desktop-modal');
    
    // 阻止视频区域的点击事件冒泡
    const videoContainer = desktopModal.querySelector('.modal-main');
    if (videoContainer) {
      videoContainer.addEventListener('click', (e) => {
        // 如果点击的是视频或 YouTube 容器，不关闭弹框
        if (e.target.tagName === 'VIDEO' || 
            e.target.closest('.youtube-container') || 
            e.target.closest('.mute-control')) {
          e.stopPropagation();
        }
      });
    }

    // 只在点击模态框背景时关闭
    desktopModal.addEventListener('click', (e) => {
      // 如果点击的是模态框本身（背景），则关闭
      if (e.target === desktopModal) {
        closeVideoModal();
      }
    });
  }

  // 添加 updateNavigationButtons 函数
  function updateNavigationButtons() {
    if (!currentElement || !currentSection) return;
    
    const currentIndex = Array.from(currentVideoElements).indexOf(currentElement);
    const totalVideos = currentVideoElements.length;
    
    const prevIndex = (currentIndex - 1 + totalVideos) % totalVideos;
    const nextIndex = (currentIndex + 1) % totalVideos;
    
    const prevVideo = currentVideoElements[prevIndex];
    const nextVideo = currentVideoElements[nextIndex];
    
    const prevButton = modal.querySelector('.modal-nav-prev');
    const nextButton = modal.querySelector('.modal-nav-next');
    
    if (!prevButton || !nextButton) return;
    
    const hasPrevVideo = prevVideo && (prevVideo.dataset.videoShopify || prevVideo.dataset.videoYoutube);
    const hasNextVideo = nextVideo && (nextVideo.dataset.videoShopify || nextVideo.dataset.videoYoutube);
    
    if (!hasPrevVideo && !hasNextVideo) {
      prevButton.disabled = true;
      nextButton.disabled = true;
      return;
    }
    
    prevButton.disabled = !hasPrevVideo;
    nextButton.disabled = !hasNextVideo;
  }

  // 修改产品链接点击处理
  function initProductLinks() {
    // 使用事件委托来处理所有产品链接的点击
    modal.addEventListener('click', (e) => {
      // 检查点击的是否是 Shop Now 链接
      const shopNowLink = e.target.closest('.product-link');
      if (!shopNowLink) return;
      
      // 阻止默认行为
      e.preventDefault();
      e.stopPropagation();
      
      // 获取目标 URL
      const url = shopNowLink.href;
      
      // 立即静音所有视频
      const videos = document.querySelectorAll('video');
      videos.forEach(video => {
        if (video) {
          video.muted = true;
        }
      });
      
      // 立即静音 YouTube 视频
      if (modal.youtubePlayer) {
        try {
          modal.youtubePlayer.mute();
        } catch (err) {
          console.error('Error muting YouTube player:', err);
        }
      }
      
      // 更新全局静音状态
      modal.isMuted = true;
      
      // 更新所有静音按钮状态
      const muteControls = document.querySelectorAll('.mute-control');
      muteControls.forEach(control => {
        const volumeOn = control.querySelector('.icon-volume-on');
        const volumeOff = control.querySelector('.icon-volume-off');
        if (volumeOn && volumeOff) {
          volumeOn.style.display = 'none';
          volumeOff.style.display = 'block';
        }
      });
      
      // 强制更新视频状态
      updateAllVideosMuteState(true);
      
      // 直接跳转到目标页面
      window.location.href = url;
    });
    
    // 防止重复初始化
    modal.dataset.productLinksInitialized = 'true';
  }
}


window.addEventListener('load', initVideoModal);


  
  
  